// extracted by mini-css-extract-plugin
module.exports = {"icon":"style_icon__2nKhB","small":"style_small__26qow","large":"style_large__3dSAF"};